module.exports = __webpack_public_path__ + "img/日志管理.c1d14f9f.svg";